export default __webpack_public_path__ + "media/images/images_v2/hover3-9034d279435ceff1b770f93b81736710.png";